import { handleRoute } from "../https";

export const getAdhesionRateData = async ({ companyId }) => {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/stats/activation`,
  });
  return res;
};

export const getConsumptionsData = async ({ companyId, filters }) => {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/stats/consumption?${filters}`,
  });
  return res;
};
